module.exports = __webpack_public_path__ + "media/packs/images/state/small/emptyreturn-516f2be53e84e5ff631956bb7a811a34.svg";